import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { getAccountIsRBL } from '@helpers/Accounts/getAccountIsRBL';
import { getAccountLatestFormalOfferTimeOutDate } from '@helpers/Accounts/getAccountsLatestFormalOfferTimeOutDate';
import { getTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus';
import { fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export const useGetTopupApprovedBannerData = (
    accountId: NonNullable<TAccount['account_id']>
) => {
    const stateKey = useStateKey();

    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            ),
        suspense: true
    });
    const { data: applicationResponse } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () =>
            fetchGetApplication({
                stateKey
            }),
        suspense: true
    });

    if (!account || !applicationResponse) {
        throw new Error();
    }
    const topupStatus = getTopUpStatus(account, applicationResponse.data);

    return {
        topUpApprovalTimeOut: getAccountLatestFormalOfferTimeOutDate(account),
        approvalAmount: account.latest_formal_offer.available_cash || 0,
        interestRate: account.latest_formal_offer.interest_rates?.[0]?.rate,
        topupStatus,
        isPreApproved: topupStatus === 'PRE_APPROVED',
        applicationStatus: applicationResponse.data?.status,
        isRBL: getAccountIsRBL(account),
        isRepaymentReduction: Boolean(
            account.latest_formal_offer.is_repayment_reduction
        )
    };
};
